/**
 * Caps the runaway feedback loop viewport-relative merchant CSS (e.g.
 * `body{min-height:110vh}`) would otherwise drive in a frame sized to its
 * content: taller frame, taller body.
 */
export const MAX_FRAME_HEIGHT_PX = 4096;

export function observeBlockContentHeight(
  element: HTMLElement,
  reportHeight: (height: number) => void,
): () => void {
  let animationFrame: number | null = null;
  let lastHeight: number | null = null;

  const measure = () => {
    animationFrame = null;
    const height = Math.ceil(
      Math.max(element.getBoundingClientRect().height, element.scrollHeight),
    );
    if (height === lastHeight) {
      return;
    }
    lastHeight = height;
    reportHeight(height);
  };

  const scheduleMeasurement = () => {
    if (animationFrame !== null) {
      return;
    }
    animationFrame = requestAnimationFrame(measure);
  };

  const observer = new ResizeObserver(scheduleMeasurement);
  observer.observe(element);
  scheduleMeasurement();

  return () => {
    observer.disconnect();
    if (animationFrame !== null) {
      cancelAnimationFrame(animationFrame);
    }
  };
}
